import { createSlice } from '@reduxjs/toolkit'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
const initialState = {
  data: 0,
}

const apiUrl = process.env.REACT_APP_API_URL

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes

      console.warn('my auth state', action.payload)
      state.data = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const { setAuth, } = authSlice.actions

export default authSlice.reducer


export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl, prepareHeaders: (headers, { getState }) => {
      const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

      // Si un token est disponible, ajoutez-le aux en-têtes
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set('Content-type', 'application/json');
      headers.set('Accept', 'application/json');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `/auth/local?populate=*`,

        method: 'POST',
        body: data
      }),
    }),

    register: builder.mutation({
      query: (data) => ({
        url: `/auth/local/register`,

        method: 'POST',
        body: data
      }),
    }),

    forgetPassword: builder.mutation({
      query: (data) => ({
        url: `/auth/forgot-password`,

        method: 'POST',
        body: data
      }),
    }),

    resetPassword: builder.mutation({
      query: (data) => ({
        url: `/auth/reset-password`,

        method: 'POST',
        body: data
      }),
    }),
    me: builder.query({
      query: () => ({
        url: `/users/me?populate=*`,
        method: 'GET',
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation, useRegisterMutation, useMeQuery, useLazyMeQuery, useForgetPasswordMutation, useResetPasswordMutation } = authApi